import { render, staticRenderFns } from "./ApplicantList.vue?vue&type=template&id=53100906&scoped=true&"
import script from "./ApplicantList.vue?vue&type=script&lang=js&"
export * from "./ApplicantList.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantList.vue?vue&type=style&index=0&id=53100906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53100906",
  null
  
)

export default component.exports